import { render, staticRenderFns } from "./DataCenter.vue?vue&type=template&id=302aef74&scoped=true&"
import script from "./DataCenter.vue?vue&type=script&lang=js&"
export * from "./DataCenter.vue?vue&type=script&lang=js&"
import style0 from "./DataCenter.vue?vue&type=style&index=0&id=302aef74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302aef74",
  null
  
)

export default component.exports